import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { logoutPopupRequest } from '@/authConfig';
import { useMsal } from '../composition-api/useMsal';
import WelcomeName from './WelcomeName.vue';
    

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { instance } = useMsal();

// const logoutRedirect = () => {
//   instance.logoutRedirect({
//     account: instance.getActiveAccount(),
//   });
// }
const logoutPopup = async () => {
  await instance.logoutPopup({
    account: instance.getActiveAccount(),
    ...logoutPopupRequest
});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WelcomeName),
    _createElementVNode("button", {
      onClick: logoutPopup,
      class: "inline-block leading-8 px-4 py-2 text-white hover:bg-purple"
    }, "Logout")
  ], 64))
}
}

})